// extracted by mini-css-extract-plugin
export default {"root":"h3brv_fU","text":"pE8W2tDO","auth":"UJ8UOdpl"};